import React from 'react'

const SortDesc = ({ numeric }) => (
  <span
    className={`sort-icon glyphicon glyphicon-sort-by-${numeric ? 'order' : 'alphabet'}-alt`}
  />
)
export default SortDesc
